export enum UnrealisedCashFXGainOrLossType {
  UnrealisedCashFXGain = 'UnrealisedCashFXGain',
  UnrealisedCashFXLoss = 'UnrealisedCashFXLoss',
  UnrealisedCashFXUnwindGain = 'UnrealisedCashFXUnwindGain',
  UnrealisedCashFXUnwindLoss = 'UnrealisedCashFXUnwindLoss',
}

export enum UnrealisedCashFXGainOrLossActionType {
  UnrealisedCashFXGainOrLossCreated = 'UnrealisedCashFXGainOrLossCreated',
}
